import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IAllNamedTypes } from '@app/core/interfaces';
import { IWizardSchema } from 'common-lib';

@Injectable({
    providedIn: 'root'
})
export class ScheduleService {
    constructor(private apiService: ApiService) {}

    public getUser() {
        return this.apiService.get('user');
    }

    public getWizardSkill(wizardSkill: string): Observable<IWizardSchema> {
        return this.apiService.get(`wizard/${wizardSkill}`);
    }

    /** This endpoint returns a dictionary object of meeting types that we return in addition to an array alternative  */
    public getMeetingTypes() {
        return this.apiService.get('user/meeting').pipe(
            map(
                (
                    meetingTypes: {
                        [path in string]: IAllNamedTypes & { videoProviderObj: { id: string; type: string } };
                    }
                ) => {
                    const meetingTypeEntries = Object.entries(meetingTypes);
                    const mergedEntries = meetingTypeEntries.map((entry: [string, IAllNamedTypes]) => {
                        return {
                            name: {
                                value: entry[0]
                            },
                            style: entry[1].style || 'meeting',
                            ...entry[1]
                        };
                    });

                    return { meetingTypeArray: Object.values(mergedEntries) as IAllNamedTypes[], meetingTypes };
                }
            )
        );
    }

    public getSuggestedTimes(type: string) {
        return this.apiService.get(`meeting/${type}/suggestTimes`, {
            responseType: 'text'
        });
    }
}
